var modules_1e09d314 = {"container":"_4iqia","active":"_7dcmm1","size-36":"_nmpiaq","size-44":"_1w36nbz"};
import "../../../assets/wxE-u8gq.css";

export { modules_1e09d314 as default };
//# sourceMappingURL=Tag.module.less.js.map
